<template>
  <div class="page section">
    <div class="main_content">
      <div class="content_title">
        <div style="display: flex;flex-direction: column;">
          <p class="title white">更多资讯</p>
          <img src="../../assets/line.png" class="line" style="margin-top: 20px" alt="" />
          <p class="subtitle white">More news</p>
        </div>
        <div @click="goBack" class="tc" style="cursor: pointer;">
          <div class="blue">返回 ></div>
          <img src="../../assets/small_line.png" class="small_line" style="margin-top: 6px" alt="" />
        </div>
      </div>
      <div id="tabs">
        <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="小鳗动态" name="1">
            <div class="title_item" v-for="item in list" :key="item.aid" @click="toDetail(item)">
              <img src="../../assets/news/new_icon.png" />
              {{ item.title }}
            </div>
            <!-- <div  class="title_item" v-for="item in 100" >
            {{ item }}
          </div> -->
          </el-tab-pane>
          <el-tab-pane label="行业资讯" name="2">
            <div class="title_item" v-for="item in list" :key="item.aid" @click="toDetail(item)">
              <img src="../../assets/news/new_icon.png" />

              {{ item.title }}
            </div>
          </el-tab-pane>
          <el-tab-pane label="小鳗课堂" name="3">
            <div class="title_item" v-for="item in list" :key="item.aid" @click="toDetail(item)">
              <img src="../../assets/news/new_icon.png" />

              {{ item.title }}
            </div>
          </el-tab-pane>
          <!-- GEO 整改 - FAQ 分类 tab -->
          <el-tab-pane label="行业FAQ" name="4">
            <div class="title_item" v-for="(item, idx) in faqList" :key="'faq-'+idx" @click="goFaqDetail(item)">
              <img src="../../assets/news/new_icon.png" />
              <span class="faq-q-prefix">Q.</span>
              {{ item.question }}
            </div>
            <div class="faq-footer" v-if="faqList.length">
              <span>共 {{ faqList.length }} 个常见问题，</span>
              <a @click="goFaqAll" href="javascript:void(0)">查看全部 FAQ 详情 &gt;</a>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import anime from "animejs";

export default {
  name: "news",
  data () {
    return {
      currentScroll: 0,
      work: [],

      tabPosition: "left",
      direction: "rtl",
      type: 1,
      list: [],
      activeName: 1,
      // GEO 整改 - 行业FAQ 列表(与 /faq 详情页保持一致)
      faqList: [
        { question: '小鳗管家能源管理系统主要监测哪些能源类型？', answer: '支持电、水、燃气、暖通空调(冷/热)、蒸汽、压缩空气等多种能源介质的实时监测与分项计量。' },
        { question: '计量收费系统支持哪些计费模式？', answer: '支持预付费、后付费、混合计费等多种模式,实现商户水电气冷热分户计量与费用分摊。' },
        { question: '暖通空调节能算法系统能带来多少节能效果？', answer: '根据实测数据,平均节能率在 15%-30% 之间,部分项目可达 35% 以上。' },
        { question: '智慧照明系统需要更换原有灯具吗？', answer: '不一定。兼容主流智能灯具、调光驱动、继电器模块、感应器等设备,提供"利旧改造+智能化升级"方案。' },
        { question: '动力储能回馈系统适用于哪些场景？', answer: '应用于电梯势能回收、制动能量回收等场景,适用于高层建筑、轨道交通、工业自动化等场合。' },
        { question: '商业综合体能源管控方案能解决哪些核心痛点？', answer: '解决能耗统计难、运营成本高、空调/照明等用能浪费、商户分户计费复杂、配电安全隐患等痛点。' },
        { question: '空调分户计费的准确度如何？', answer: '采用时间面积法+实际用量的混合计费模型,准确度可达 95% 以上。' },
        { question: '智慧园区解决方案的部署周期一般是多久？', answer: '小型园区 1 个月内、中型园区 1-2 个月、大型园区 2-3 个月或更长。' },
        { question: '绿色校园解决方案包含哪些核心功能？', answer: '包含校园能耗实时监测、分类分项计量、能耗对标分析、节能诊断告警、碳排放核算等功能。' },
        { question: '系统支持私有化部署吗？', answer: '支持 SaaS 公有云、私有云、本地化部署等多种交付方式,所有数据可本地存储,满足等保要求。' },
        { question: '能源管理系统报价依据是什么？', answer: '依据项目规模、产品配置、功能模块、实施服务等综合因素。具体请联系商务团队 028-86533354。' },
        { question: '是否提供渠道代理或 OEM 合作？', answer: '欢迎渠道商、集成商洽谈合作,提供技术培训、项目报备、阶梯返点、市场推广支持。' },
        { question: '采购流程是怎样的？', answer: '需求沟通→方案设计→商务报价→合同签订→项目实施→验收交付→售后运维。' },
        { question: '项目实施流程是怎样的？', answer: '需求调研→方案设计→设备采购→现场安装→系统联调→试运行→项目验收→售后运维。' },
        { question: '系统对网络环境有什么要求？', answer: '支持 4G/5G、宽带互联网、局域网、专网等多种网络环境。' },
        { question: '是否提供操作培训？', answer: '提供管理员/操作员培训、操作手册、视频教程,以及远程/现场技术支持,7x24 应急响应。' },
        { question: '质保期是多久？售后如何收费？', answer: '标准质保 12 个月,主要硬件 24 个月。质保期内免费上门维修与软件升级。' },
        { question: '系统出现故障如何处理？', answer: '请联系客服 028-86533354 或提交工单。常规问题 4 小时内响应,紧急故障 1 小时内响应。' },
        { question: '辰鳗科技集团成立于什么时候？', answer: '辰鳗科技集团有限公司成立于 2020 年 1 月,总部位于四川省成都市双流区电子科大科技园。' },
        { question: '辰鳗科技有哪些核心资质？', answer: '高新技术企业认证、ISO9001/14001/27001 三体系认证、CMMI3、建筑机电/电子智能化/电力工程等多项资质。' }
      ]
    };
  },

  created () {
    console.log(this.$route)
    this.type = this.$route.params.type;
    this.activeName = this.type+'';

    this.getNew(this.type);
  },
  mounted () {
    window.scrollTo(0,0)
  },
  methods: {
    goBack () {
      this.$router.back();
    },
    handleClick (tab) {
      this.activeName = tab.name;
      this.type = tab.name;
      // GEO 整改 - FAQ tab 不调用 getNew API
      if (this.type !== '4') {
        this.getNew(this.type);
      }
      console.log("112313");
    },
    toDetail (item) {
      this.$router.push({
        path: '/newDetail/'+ item.type + '_' + item.aid + '.html'
      })
    },
    // GEO 整改 - 跳转 FAQ 详情页(可携带 question 高亮)
    goFaqDetail (item) {
      this.$router.push({
        path: '/faq',
        query: { q: encodeURIComponent(item.question) }
      })
    },
    // GEO 整改 - 跳转 FAQ 全部列表
    goFaqAll () {
      this.$router.push('/faq')
    },

    getNew (type) {
      var params = new URLSearchParams();
      params.append("start", 1);
      params.append("limit", 9999);
      params.append("type", type);
      this.$axios.post("/api/websiteNews/websiteList", params).then(res => {
        this.list = JSON.parse(JSON.stringify(res.data.data.records));
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/style/more.scss';
.page {
  width: 100%;
  background: url('../../assets/news_bg.png') no-repeat;
  background-position: center;
  background-size: cover;
}

.content_title {
  display: flex;
  justify-content: space-between;
  padding-top: 100px;
  text-align: left;
  align-items: flex-end;
}

.title {
  font-size: 48px;
  font-family: 'PangMenZhengDao';
  font-weight: 400;
  letter-spacing: 6px;
}
.subtitle {
  font-size: 24px;
  font-family: 'PangMenZhengDao';
  font-weight: 400;
  margin-top: 20px;
}
#tabs {
  height: 490px;
  background: rgba(41, 46, 54, 0.60);
  margin-top: 60px;
}

//滚动条的宽度
::-webkit-scrollbar {
  width: 4px;
  height: 100%;
  background: #5c76a9;
  opacity: 0.2;
}

::-webkit-scrollbar-button {
  display: none;
}
// 滚动条的轨道（里面装有Thumb）
::-webkit-scrollbar-track {
  background: transparent;
}
// 滚动条的轨道（里面装有Thumb）
::-webkit-scrollbar-track-piece {
  background-color: transparent;
}
// 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
::-webkit-scrollbar-thumb {
  width: 8px !important;
  height: 100px;
  background: #3e4d6d;
  cursor: pointer;
  border-radius: 4px;
  z-index: 9;
}
/deep/ .el-tab-pane {
  /* background: #697; */
  height: 380px;
  overflow-y: auto;
}
/deep/ .el-tabs__header {
  padding-top: 60px;
}
/deep/ .el-tabs__content {
  padding-top: 60px;
  margin-left: 60px;
}
/deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after {
  width: 0 !important;
}
/deep/ .el-tabs__item:hover {
  background: linear-gradient(to right, rgba(49, 112, 255, 0.3), #283040);
  /* border-left: 4px solid #3170ff !important; */
}
/deep/ .el-tabs__active-bar {
  background: transparent !important;
}
/deep/ .el-tabs__item {
  text-align: left !important;
  padding: 0 40px !important;
  width: 200px;
  height: 42px;
  line-height: 42px;
  font-size: 16px;
  color: #fff;
  border-left: 4px solid transparent !important;
}
>>> .el-tabs__item.is-active {
  background: linear-gradient(
    to right,
    rgba(49, 112, 255, 0.3),
    #283040
  ) !important;
  border-left: 4px solid #3170ff !important;
}
.title_item {
  width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  height: 48px;
  text-align: left;
  line-height: 48px;
  color: #ffffff;
  font-size: 16px;
  font-family: 'Regular';
  font-weight: 400;
  color: #fdfeff;
  border-bottom: 1px solid;
  border-image: linear-gradient(
      to right,
      #6b6767 rgba(255, 255, 255, 0.3),
      rgba(82, 123, 217, 0.07)
    )
    1 10 10;
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    margin-right: 10px;
    width: 16px;
    height: 16px;
  }
}

.title_item:hover {
  /* text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  background: linear-gradient(to right, #3170ff, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; */
  background: linear-gradient(
    to right,
    rgba(49, 112, 255, 0.3) 20%,
    #283040 70%
  ) !important;
}

/* GEO 整改 - FAQ 分类 tab 样式 */
.faq-q-prefix {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 22px;
  padding: 0 8px;
  margin-right: 10px;
  background: #3170ff;
  color: #fff;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}
.faq-footer {
  margin-top: 24px;
  padding: 16px 0;
  color: #c0c4cc;
  font-size: 14px;
  text-align: left;
  border-top: 1px dashed rgba(255, 255, 255, 0.1);
}
.faq-footer a {
  color: #3170ff;
  cursor: pointer;
  margin-left: 4px;
  text-decoration: none;
}
.faq-footer a:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/page/more.vue